import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UsePermissionsOperationKlassesProps<T> = {
  filters?: {
    search?: string
  }
  mapper?: (data: any) => T,
}

export const usePermissionsOperationKlasses = <T,>({
  filters: { search = '' } = {},
  mapper = Mapper.default<T>(),
}: UsePermissionsOperationKlassesProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['permissions-operation-klasses', search],
    queryFn: () => {
      return privateAxios.get(`/permissions/operation_klasses`, {
        params: {
          search,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, isPending, ...rest }
}
